import { Component } from "@angular/core";
import { AnimationComponent } from "../../shared/components/animation/animation.component";
import { MatDivider } from "@angular/material/divider";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "onsip-signup-pagesize-modal",
  templateUrl: "./signup-pagesize-modal.component.html",
  styleUrls: ["./signup-pagesize-modal.component.scss"],
  imports: [AnimationComponent, MatDivider, TranslateModule]
})
export class PageSizeModalComponent {}
